export const TYPES = ['left', 'right']
